import React from "react";
import BlueprintWidget from "@/components/cards/widgets/ObjectsWidget";
import { CardData } from "./GridLayout";
import { getShadowProps } from "./shadowUtils";

interface CardGridProps {
  cards: CardData[];
  gridSize: "1" | "2" | "3" | "4" | "5" | "6";
  shadowMode: "none" | "black" | "status" | "template" | "folder";
  onCardClick?: (card: CardData) => void;
  onDelete?: (id: string, gameId: string) => void;
  onEdit?: (id: string) => void;
  renderCard?: (card: CardData) => React.ReactNode;
}

const gridSizeClasses = {
  "6": "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6",
  "5": "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-5",
  "4": "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4",
  "3": "grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3",
  "2": "grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2",
  "1": "grid-cols-1",
};

export default function CardGrid({
  cards,
  gridSize,
  shadowMode,
  onCardClick,
  onDelete,
  onEdit,
  renderCard,
}: CardGridProps) {
  return (
    <div className={`grid gap-6 ${gridSizeClasses[gridSize]}`}>
      {cards.map((card) => {
        const shadowProps = getShadowProps(card, shadowMode);
        const cardWithShadow = { ...card, ...shadowProps };
        
        return (
          <div 
            key={card.id} 
            data-card-item 
            className="flex flex-col" 
            style={{ aspectRatio: '1 / 1', maxHeight: '100%' }}
          >
            {renderCard ? (
              <div
                onClick={() => onCardClick?.(card)}
                className="cursor-pointer h-full flex flex-col"
              >
                {renderCard(cardWithShadow)}
              </div>
            ) : (
              <div
                onClick={() => onCardClick?.(card)}
                className="cursor-pointer h-full flex flex-col"
              >
                <BlueprintWidget
                  id={card.id}
                  gameId={card.gameId}
                  title={card.title}
                  creator={card.creator}
                  tags={card.tags}
                  description={card.description}
                  lastUpdate={card.lastUpdate}
                  folder={card.folder as string}
                  itemType={
                    (card.itemType as
                      | "library"
                      | "documents"
                      | "templates"
                      | "dialogs") || "library"
                  }
                  icon={card.icon}
                  iconBg={card.iconBg}
                  shadowType={shadowProps.shadowType as any}
                  version={card.version}
                  shadowColor={shadowProps.shadowColor}
                  hasVersionMismatch={card.hasVersionMismatch}
                  onDelete={onDelete}
                  onEdit={onEdit}
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

